import {
    apiRequest,
    presensiDetail,
    presensiListPresensi,
    presensiupdate,
    presensiExport,
    PegawaiEmployeeList
} from "../../../../../services/adapters/kepegawaian/presensiService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", presensiDetail, {
            params: query
        }, true)
    }

    fetchListPresensi = async (query) => {
        return await apiRequest("get", presensiListPresensi, {
            params: query
        }, true)
    }

    fetchUpdatePresensi = async (query) => {
        return await apiRequest("post", presensiupdate, {
            params: query
        }, true)
    }
    fetchExport = async (query) => {
        return await apiRequest("get", presensiExport, {
            params: query
        }, true)
    }

    fetchEmployeeList = async (query, cancelToken) => {
        return await apiRequest("get", PegawaiEmployeeList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DetailRepository